/* import __COLOCATED_TEMPLATE__ from './actions-select-paywalled-item-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();